module.exports = __webpack_public_path__ + "media/images/logo-color-text-white-big-8a578c01f40c043cf738629b51c6c4e3.png";